module.exports = __webpack_public_path__ + "static/media/cred_mod_C_secc.84b9c3a5.png";